import React from "react";
import Page from "components/page/Page";
import BillingTabs from "./tabs/BillingTabs";
import { useTranslation } from "react-i18next";

export default function PortalBilling() {
  const { t } = useTranslation();

  return (
    <Page full title={t("Billing")} subtitle={t("Manage and settle your account here")}>
      <hr />

      <div>
        <BillingTabs />
      </div>
    </Page>
  );
}
